export const PAGE_KEY = 'attendance-admin-requests';
